/**
 * @license Codistica
 *
 * Copyright (c) 2020, Codistica and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * BUILD DATE: Fri Jul 10 2020 16:51:08 GMT+0200 (Central European Summer Time)
 */
import _bindInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/bind";
import _newArrowCheck from "@babel/runtime-corejs3/helpers/esm/newArrowCheck";

/** @module core/modules/create-state-promise */

/**
 * @typedef createStatePromiseWrappedPromiseType
 * @property {function(): boolean} [isPending] - Is pending method.
 * @property {function(): boolean} [isRejected] - Is rejected method.
 * @property {function(): boolean} [isFulfilled] - Is fulfilled method.
 */

/**
 * @description Wraps input promise with useful methods.
 * @param {Promise<*>} promise - Input promise.
 * @returns {*} Wrapped promise.
 */
function createStatePromise(promise) {
  var _this = this,
      _context,
      _context2,
      _context3,
      _context4,
      _context5;

  if (Object.hasOwnProperty.call(promise, 'isPending')) {
    return promise;
  }

  var isPending = true;
  var isRejected = false;
  var isFulfilled = false;
  /** @type {*} */

  var wrappedPromise = promise.then(_bindInstanceProperty(_context = function _context(value) {
    _newArrowCheck(this, _this);

    isFulfilled = true;
    isPending = false;
    return value;
  }).call(_context, this), _bindInstanceProperty(_context2 = function _context2(err) {
    _newArrowCheck(this, _this);

    isRejected = true;
    isPending = false;
    throw err;
  }).call(_context2, this));
  wrappedPromise.isFulfilled = _bindInstanceProperty(_context3 = function _context3() {
    _newArrowCheck(this, _this);

    return isFulfilled;
  }).call(_context3, this);
  wrappedPromise.isPending = _bindInstanceProperty(_context4 = function _context4() {
    _newArrowCheck(this, _this);

    return isPending;
  }).call(_context4, this);
  wrappedPromise.isRejected = _bindInstanceProperty(_context5 = function _context5() {
    _newArrowCheck(this, _this);

    return isRejected;
  }).call(_context5, this);
  return wrappedPromise;
}

export { createStatePromise };